const CACHE_DELETE_TIMEOUT_MS = 4000;

function withTimeout<T>(promise: Promise<T>, timeoutMs: number): Promise<T | undefined> {
  return new Promise((resolve) => {
    const timeout = window.setTimeout(() => resolve(undefined), timeoutMs);
    promise
      .then((value) => resolve(value))
      .catch(() => resolve(undefined))
      .finally(() => window.clearTimeout(timeout));
  });
}

async function deleteBrowserCaches() {
  if (!("caches" in window)) return;

  const cacheNames = await caches.keys();
  await Promise.allSettled(cacheNames.map((cacheName) => caches.delete(cacheName)));
}

async function unregisterServiceWorkers() {
  if (!("serviceWorker" in navigator)) return false;

  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.allSettled(
    registrations.map(async (registration) => {
      await registration.update().catch(() => undefined);
      await registration.unregister();
    }),
  );

  return registrations.length > 0;
}

export function clearStaleAppShells() {
  if (typeof window === "undefined") return;
  if (!/^https?:$/.test(window.location.protocol)) return;

  void (async () => {
    const hadRegistrations = await unregisterServiceWorkers().catch(() => false);
    await withTimeout(deleteBrowserCaches(), CACHE_DELETE_TIMEOUT_MS);

    if (hadRegistrations && navigator.serviceWorker?.controller) {
      window.location.reload();
    }
  })();
}